import { render, staticRenderFns } from "./ValidationTest.vue?vue&type=template&id=3dcf62e2&"
import script from "./ValidationTest.vue?vue&type=script&lang=js&"
export * from "./ValidationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports